import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faComments } from "@fortawesome/free-solid-svg-icons"

const NoChat = () => {
    return (
        <div className='flex-1 h-full flex flex-col items-center justify-center gap-3 px-6 text-center smallTablet:hidden'>
            <div className='h-14 w-14 rounded-2xl bg-indigo-500/10 flex items-center justify-center'>
                <FontAwesomeIcon icon={faComments} className='text-[20px] text-indigo-500' />
            </div>
            <h2 className='text-[16px] font-bold text-text-primary'>No conversation selected</h2>
            <p className='text-[13px] font-medium text-light-gray max-w-[280px]'>
                Pick a customer from the list to read their messages and reply.
            </p>
        </div>
    )
}

export default NoChat
